import { render, staticRenderFns } from "./HiveMindTextFormatter.vue?vue&type=template&id=43c1d79e&scoped=true&"
import script from "./HiveMindTextFormatter.vue?vue&type=script&lang=js&"
export * from "./HiveMindTextFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1d79e",
  null
  
)

export default component.exports